export const requiredFlags = [
    "isMileageArticleShowInInvoice",
    "isArticleShowInInvoiceOS",
    "isArticleShowInInvoiceIS",
    "isTravelArticleShowInInvoice",
    "isMaterialArticleShowInInvoice",
];